import {checkIsDocTypeWithDuplexScan, getDocTypesWithoutMrz} from '../../utils/docTypes';
import {useComputedReservationDetails} from '../../context/computedReservationDetails';

type UseIdentityVerificationProps = {
  nationality: string;
  documentType: string;
};
function useIdentityVerification({
  nationality,
  documentType,
}: UseIdentityVerificationProps) {
  const {reservation} = useComputedReservationDetails();
  const docTypesWithoutMrz = getDocTypesWithoutMrz(reservation, nationality);
  const isNeedCheckMrz = !docTypesWithoutMrz.includes(documentType);
  const isDocTwoSides = checkIsDocTypeWithDuplexScan({
    docType: documentType,
    nationality,
  });

  return {isNeedCheckMrz, isDocTwoSides};
}

export {useIdentityVerification};
